module.exports = __webpack_public_path__ + "img/pcControll.6acb9eb2.png";